// NYU's undergraduate majors (#2596, founder 2026-09-30: "majors offered by
// the college in the public page"). Read on 2026-09-30 from NYU's official
// Bulletins, one Programs page per school (bulletins.nyu.edu/undergraduate/
// <school>/programs/): every line with a bachelor's or associate degree in
// parentheses; minors and certificates left out. The School of Global Public
// Health lists its combined majors without a degree. Flags quote NYU's
// Additional Program Requirements page (the college file's `programs` source).
// Typography is plain ASCII (non-breaking spaces and en dashes in the
// Bulletins become spaces and hyphens). The KB's majors list was the starting
// point; the Bulletins win.
const majors = {
    "slug": "new-york-university",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in NYU's official Bulletins, grouped by the school that offers it, with the degree it leads to. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Science",
            "source": {
                "label": "NYU Bulletins, College of Arts and Science, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/arts-science/programs/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology and Classical Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Asian/Pacific/American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology/Chemical and Biomolecular Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Biology/Dentistry",
                    "degree": "BA/DDS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry/Chemical and Biomolecular Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Cinema Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classical Civilization",
                    "degree": "BA"
                },
                {
                    "name": "Classical Civilization and Hellenic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Classics and Art History",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Computer and Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science/Computer Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Computer Science/Electrical Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Data Science and Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Dramatic Literature, Theatre History, and Cinema",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics and Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Economics and Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "English and American Literature",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "European and Mediterranean Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "French and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "German and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Global Public Health and Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Global Public Health and History",
                    "degree": "BA"
                },
                {
                    "name": "Global Public Health and Science",
                    "degree": "BS"
                },
                {
                    "name": "Global Public Health and Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Hebrew and Judaic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Hellenic Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Italian and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Language and Mind",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latino Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics/Civil Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Mathematics/Computer Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Mathematics/Electrical Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Mathematics/Mechanical Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Medieval and Renaissance Studies",
                    "degree": "BA"
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neural Science",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics/Civil Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Physics/Computer Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Physics/Electrical Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Physics/Mechanical Engineering",
                    "degree": "BS/BS"
                },
                {
                    "name": "Politics",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Romance Languages",
                    "degree": "BA"
                },
                {
                    "name": "Russian and Slavic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Social and Cultural Analysis",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Spanish and Portuguese",
                    "degree": "BA"
                },
                {
                    "name": "Urban Design and Architecture Studies",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies and Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies and History",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies and Social and Cultural Analysis",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies and Sociology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Tandon School of Engineering",
            "source": {
                "label": "NYU Bulletins, Tandon School of Engineering, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/engineering/programs/"
            },
            "majors": [
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Biomolecular Science",
                    "degree": "BS"
                },
                {
                    "name": "Business and Technology Management",
                    "degree": "BS"
                },
                {
                    "name": "Chemical and Biomolecular Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science/Management of Technology",
                    "degree": "BS/MS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Integrated Design and Media",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Physics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ],
            "note": "Competitive applicants have physics, chemistry and calculus (or at least precalculus) on their transcript.",
            "noteSource": "programs"
        },
        {
            "name": "Tisch School of the Arts",
            "source": {
                "label": "NYU Bulletins, Tisch School of the Arts, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/arts/programs/"
            },
            "majors": [
                {
                    "name": "Cinema Studies",
                    "degree": "BA"
                },
                {
                    "name": "Collaborative Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Dramatic Writing",
                    "degree": "BFA"
                },
                {
                    "name": "Film and Television",
                    "degree": "BFA"
                },
                {
                    "name": "Game Design",
                    "degree": "BFA"
                },
                {
                    "name": "Interactive Media Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Performance Studies",
                    "degree": "BA"
                },
                {
                    "name": "Photography and Imaging",
                    "degree": "BFA"
                },
                {
                    "name": "Recorded Music",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                }
            ],
            "note": "Every Tisch program requires an artistic review: a portfolio or an audition.",
            "noteSource": "programs"
        },
        {
            "name": "Steinhardt School of Culture, Education, and Human Development",
            "source": {
                "label": "NYU Bulletins, Steinhardt School of Culture, Education, and Human Development, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/culture-education-human-development/programs/"
            },
            "majors": [
                {
                    "name": "Applied Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Childhood Education/Childhood Special Education",
                    "degree": "BS"
                },
                {
                    "name": "Communicative Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education/Early Childhood Special Education",
                    "degree": "BS"
                },
                {
                    "name": "Education Studies",
                    "degree": "BA"
                },
                {
                    "name": "Educational Theatre",
                    "degree": "BS"
                },
                {
                    "name": "Global Public Health/Applied Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Global Public Health/Communicative Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Global Public Health/Food Studies",
                    "degree": "BS"
                },
                {
                    "name": "Global Public Health/Media, Culture, and Communication",
                    "degree": "BS"
                },
                {
                    "name": "Global Public Health/Nutrition and Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Health and Wellbeing Studies",
                    "degree": "BS"
                },
                {
                    "name": "Instrumental Performance",
                    "degree": "BM"
                },
                {
                    "name": "Media, Culture, and Communication",
                    "degree": "BS"
                },
                {
                    "name": "Music Business",
                    "degree": "BM",
                    "flag": "An audition, portfolio or supplemental application is required for all Music programs.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music Business",
                    "degree": "BS",
                    "flag": "An audition, portfolio or supplemental application is required for all Music programs.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music Technology",
                    "degree": "BM",
                    "flag": "An audition, portfolio or supplemental application is required for all Music programs.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music Theory and Composition",
                    "degree": "BM",
                    "flag": "An audition, portfolio or supplemental application is required for all Music programs.",
                    "flagSource": "programs"
                },
                {
                    "name": "Nutrition and Food Studies",
                    "degree": "BS"
                },
                {
                    "name": "Piano Performance",
                    "degree": "BM"
                },
                {
                    "name": "Professional Studies",
                    "degree": "BS"
                },
                {
                    "name": "Studio Art",
                    "degree": "BFA",
                    "flag": "A portfolio with an artist statement, sent to the art department.",
                    "flagSource": "programs"
                },
                {
                    "name": "Studio Art/Integrated Design and Media",
                    "degree": "BFA/MS",
                    "flag": "A portfolio with an artist statement, sent to the art department.",
                    "flagSource": "programs"
                },
                {
                    "name": "Teaching a World Language 7-12: Chinese",
                    "degree": "BS"
                },
                {
                    "name": "Teaching a World Language 7-12: French",
                    "degree": "BS"
                },
                {
                    "name": "Teaching a World Language 7-12: Italian",
                    "degree": "BS"
                },
                {
                    "name": "Teaching a World Language 7-12: Japanese",
                    "degree": "BS"
                },
                {
                    "name": "Teaching a World Language 7-12: Spanish",
                    "degree": "BS"
                },
                {
                    "name": "Teaching Biology 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Teaching Chemistry 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Teaching Earth Science 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Teaching English 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Teaching Mathematics 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Teaching Physics 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Teaching Social Studies 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Vocal Performance",
                    "degree": "BM"
                }
            ]
        },
        {
            "name": "Leonard N. Stern School of Business",
            "source": {
                "label": "NYU Bulletins, Leonard N. Stern School of Business, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/business/programs/"
            },
            "majors": [
                {
                    "name": "Business",
                    "degree": "BS"
                },
                {
                    "name": "Business and Political Economy",
                    "degree": "BS"
                },
                {
                    "name": "Business, Technology and Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Business/Accounting",
                    "degree": "BS/MS"
                }
            ],
            "note": "Applicants should have calculus, or at least precalculus, on their transcript.",
            "noteSource": "programs"
        },
        {
            "name": "School of Professional Studies",
            "source": {
                "label": "NYU Bulletins, School of Professional Studies, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/professional-studies/programs/"
            },
            "majors": [
                {
                    "name": "Applied Data Analytics and Visualization",
                    "degree": "BS"
                },
                {
                    "name": "Applied General Studies",
                    "degree": "BA"
                },
                {
                    "name": "Business",
                    "degree": "AAS"
                },
                {
                    "name": "Digital Communications and Media",
                    "degree": "BS"
                },
                {
                    "name": "Health Administration",
                    "degree": "AAS"
                },
                {
                    "name": "Healthcare Management",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "AAS"
                },
                {
                    "name": "Hospitality, Travel and Tourism Management",
                    "degree": "BS"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Information Systems and Technology",
                    "degree": "AAS"
                },
                {
                    "name": "Information Systems and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Leadership and Management",
                    "degree": "BS"
                },
                {
                    "name": "Liberal Arts",
                    "degree": "AA"
                },
                {
                    "name": "Marketing Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate and Urban Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "Social Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Rory Meyers College of Nursing",
            "source": {
                "label": "NYU Bulletins, Rory Meyers College of Nursing, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/nursing/programs/"
            },
            "majors": [
                {
                    "name": "Nursing/Global Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Dentistry",
            "source": {
                "label": "NYU Bulletins, College of Dentistry, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/dentistry/programs/"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "AAS"
                },
                {
                    "name": "Dental Hygiene",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Global Public Health",
            "source": {
                "label": "NYU Bulletins, School of Global Public Health, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/global-public-health/programs/"
            },
            "majors": [
                {
                    "name": "Global Public Health/Nursing",
                    "degree": null,
                    "note": "Combined major, with Rory Meyers College of Nursing"
                },
                {
                    "name": "Global Public Health/Social Work",
                    "degree": null,
                    "note": "Combined major, with Silver School of Social Work"
                },
                {
                    "name": "Global Public Health/Applied Psychology",
                    "degree": null,
                    "note": "Combined major, with Steinhardt School of Culture, Education and Human Development"
                },
                {
                    "name": "Global Public Health/Communicative Sciences and Disorders",
                    "degree": null,
                    "note": "Combined major, with Steinhardt School of Culture, Education and Human Development"
                },
                {
                    "name": "Global Public Health/Food Studies",
                    "degree": null,
                    "note": "Combined major, with Steinhardt School of Culture, Education and Human Development"
                },
                {
                    "name": "Global Public Health/Media, Culture, and Communication",
                    "degree": null,
                    "note": "Combined major, with Steinhardt School of Culture, Education and Human Development"
                },
                {
                    "name": "Global Public Health/Nutrition and Dietetics",
                    "degree": null,
                    "note": "Combined major, with Steinhardt School of Culture, Education and Human Development"
                },
                {
                    "name": "Global Public Health/Global Liberal Studies",
                    "degree": null,
                    "note": "Combined major, with Liberal Studies"
                },
                {
                    "name": "Global Public Health/Anthropology",
                    "degree": null,
                    "note": "Combined major, with College of Arts and Science"
                },
                {
                    "name": "Global Public Health/History",
                    "degree": null,
                    "note": "Combined major, with College of Arts and Science"
                },
                {
                    "name": "Global Public Health/Sociology",
                    "degree": null,
                    "note": "Combined major, with College of Arts and Science"
                },
                {
                    "name": "Global Public Health/Biology",
                    "degree": null,
                    "note": "Combined major, with College of Arts and Science"
                },
                {
                    "name": "Global Public Health/Chemistry",
                    "degree": null,
                    "note": "Combined major, with College of Arts and Science"
                }
            ]
        },
        {
            "name": "Silver School of Social Work",
            "source": {
                "label": "NYU Bulletins, Silver School of Social Work, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/social-work/programs/"
            },
            "majors": [
                {
                    "name": "Global Public Health and Social Work",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Liberal Studies",
            "source": {
                "label": "NYU Bulletins, Liberal Studies, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/liberal-studies/programs/"
            },
            "majors": [
                {
                    "name": "Global Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global Public Health/Global Liberal Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Gallatin School of Individualized Study",
            "source": {
                "label": "NYU Bulletins, Gallatin School of Individualized Study, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/individualized-study/programs/"
            },
            "majors": [
                {
                    "name": "Individualized Major",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Robert F. Wagner Graduate School of Public Service",
            "source": {
                "label": "NYU Bulletins, Robert F. Wagner Graduate School of Public Service, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/public-service/programs/"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "NYU Abu Dhabi",
            "source": {
                "label": "NYU Bulletins, NYU Abu Dhabi, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/abu-dhabi/programs/"
            },
            "majors": [
                {
                    "name": "Arab Crossroads Studies",
                    "degree": "BA"
                },
                {
                    "name": "Art and Art History",
                    "degree": "BA"
                },
                {
                    "name": "Bioengineering",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Business, Organizations and Society",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Film and New Media",
                    "degree": "BA"
                },
                {
                    "name": "General Engineering",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interactive Media",
                    "degree": "BA"
                },
                {
                    "name": "Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Literature and Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Social Research and Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Theater",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "NYU Shanghai",
            "source": {
                "label": "NYU Bulletins, NYU Shanghai, Programs",
                "url": "https://bulletins.nyu.edu/undergraduate/shanghai/programs/"
            },
            "majors": [
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Business and Finance",
                    "degree": "BS"
                },
                {
                    "name": "Business and Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Electrical and Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Global China Studies",
                    "degree": "BA"
                },
                {
                    "name": "Honors Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Interactive Media + Business",
                    "degree": "BS"
                },
                {
                    "name": "Interactive Media Arts",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Neural Science",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Self-Designed Honors",
                    "degree": "BA"
                },
                {
                    "name": "Social Science",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
